module.exports = __webpack_public_path__ + "img/pattern-pink.dbe7444.png";